import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initSentry, Sentry } from './lib/sentry';
import { initAnalytics } from './lib/analytics';
import { AnalyticsProvider } from './lib/analytics-provider';

initSentry('partner');
initAnalytics();

const FallbackScreen = ({ resetError }: { resetError: () => void }) => (
  <div className="min-h-screen bg-[#f6f7f4] flex items-center justify-center p-6">
    <div className="text-center max-w-sm">
      <h1 className="text-xl font-semibold mb-2">Partner app crashed.</h1>
      <p className="text-sm text-gray-600 mb-4">
        A report has been sent. Reload to continue.
      </p>
      <button
        onClick={() => { resetError(); location.reload(); }}
        className="h-10 px-5 rounded-lg bg-[#2d5016] text-white text-sm"
      >
        Reload
      </button>
    </div>
  </div>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={FallbackScreen} showDialog={false}>
      <AnalyticsProvider>
        <App />
      </AnalyticsProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
